



import Vue from 'vue'
import Folder from '@/components/Folder.vue'
export default Vue.extend({
    components: { Folder },
    props: ['folder']
})
